/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { MutationHookOptions, useMutation } from "@apollo/react-hooks";
import { GraphQLDocuments } from "@graphql/graphQLDocuments";
import { InquiryOnHoldMutation, InquiryOnHoldMutationVariables } from "@models/graphql";

const defaultInquiryOnholdOptions: MutationHookOptions<InquiryOnHoldMutation, InquiryOnHoldMutationVariables> = {};

export const useInquiryOnhold = (options?: MutationHookOptions<InquiryOnHoldMutation, InquiryOnHoldMutationVariables>) => {
    const [mutation, { data, loading, error }] = useMutation<InquiryOnHoldMutation, InquiryOnHoldMutationVariables>(
        GraphQLDocuments.inquiryOnhold
    );

    const inquiryOnhold = async (variables: InquiryOnHoldMutationVariables) => {
        try {
            const response = await mutation({
                ...defaultInquiryOnholdOptions,
                ...options,
                variables
            });

            return {
                error: undefined,
                response
            };
        } catch (err) {
            return {
                error: err,
                response: undefined
            };
        }
    };

    return {
        isLoading: loading,
        error,
        data,
        inquiryOnhold: inquiryOnhold
    };
};
